import { jwtDecode } from "jwt-decode";

export function getUserRole() {
  const token = localStorage.getItem('access_token');
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.data.role;
  } catch (error) {
    console.error('Fejl ved dekodning af token:', error);
    return null;
  }
}

export async function isAuthenticated() {
  let token = localStorage.getItem('access_token');
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const exp = decoded.exp;
    const now = Math.floor(Date.now() / 1000);

    if (exp > now) {
      return true;
    } else {
      // Forsøg at forny tokenet
      const refreshed = await refreshAccessToken();
      return !!refreshed;
    }
  } catch (error) {
    return false;
  }
}

export async function refreshAccessToken() {
  const refresh_token = localStorage.getItem('refresh_token');
  if (!refresh_token) {
    return null;
  }
  
  try {
    const response = await fetch('https://app.recyconelement.dk/api/refresh_token.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh_token }),
    });

    const data = await response.json();

    if (data.success) {
      localStorage.setItem('access_token', data.access_token);
      return data.access_token;
    } else {
      // Refresh token er udløbet eller ugyldigt
      // Log brugeren ud
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      return null;
    }
  } catch (error) {
    console.error('Fejl ved fornyelse af adgangstoken:', error);
    return null;
  }
}

export function isTokenExpired(token) {
  if (!token) return true;
  const decoded = jwtDecode(token);
  const exp = decoded.exp;
  const now = Math.floor(Date.now() / 1000);
  return exp < now;
}

export async function getAccessToken() {
  let token = localStorage.getItem('access_token');
  if (!token || isTokenExpired(token)) {
    token = await refreshAccessToken();
  }
  return token;
}

export async function logout() {
  const refresh_token = localStorage.getItem('refresh_token');
  if (refresh_token) {
    await fetch('https://app.recyconelement.dk/api/logout.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh_token }),
    });
  }

  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
}